import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, message } from 'antd';
import {
  ALERT_TOP_PANEL_DETAIL_GS_QUERY,
  LANDING_FROM,
  RETURN_TO_PATH,
  LANDED_IN
} from '../constant';
import BreadCrumb from '../../../../components/BreadCrumb';
import SmartAssessmentTopPanel from '../../components/SmartAssessmentTopPanel';
import style from './index.scss';
import {
  getAMLSCommonAlertDetails,
  putAMLSCommonAlertPartyUpdate
} from '../../../../redux/actions/common';
import { connect } from 'react-redux';

const PageHeader = ({
  alertId,
  alertDetails,
  isPrevention,
  fetchAlertDetails,
  updateUnifiedAlert,
  updateUnifiedAlertStatus = {},
  isFromCM,
  alertMetaSuffix
}) => {
  const { data = {}, isLoading } = updateUnifiedAlertStatus;
  const [disableSelectBox, setDisableSelectBox] = useState(false);

  useEffect(() => {
    if (alertId) fetchAlertDetails(alertId);
  }, [alertId]);

  useEffect(() => {
    if (!disableSelectBox || data === null) return;

    setDisableSelectBox(false);
    data?.status === 202
      ? message.success('Review feedback has been saved successfully')
      : message.error('Fail to update', data?.message);
  }, [data]);

  const onChangeAlertQuality = (alertQuality, sourceId) => {
    setDisableSelectBox(true);
    updateUnifiedAlert([{ alertId, sourceId, alertQuality }]);
  };

  return (
    <div className={style.navPanel}>
      <Row>
        <Col style={{ position: 'static' }}>
          {!isFromCM && (
            <div className={style.breadcrumb}>
              <BreadCrumb
                crumbs={[
                  {
                    label: LANDING_FROM,
                    linkTo: RETURN_TO_PATH
                  },
                  { label: LANDED_IN }
                ]}
              />
            </div>
          )}

          <div className={style.pageContentHeader}>
            <SmartAssessmentTopPanel
              isPrevention={isPrevention}
              alertHeader="Smart Assessment view"
              disableSelect={disableSelectBox}
              isFromCM={isFromCM}
              alertMetaSuffix={alertMetaSuffix}
              {...{ onChangeAlertQuality, alertDetails }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

PageHeader.propTypes = {
  settings: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  isEmbedded: PropTypes.bool,
  isFromCM: PropTypes.bool,
  alertMetaSuffix: PropTypes.element
};

const mapStateToProps = (state) => {
  const { alertDetails = {}, updateUnifiedAlertStatus = {} } = state.amlsCommon;
  return { alertDetails, updateUnifiedAlertStatus };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAlertDetails: (alertId) =>
    dispatch(getAMLSCommonAlertDetails({ alertId })),
  updateUnifiedAlert: (payload) =>
    dispatch(putAMLSCommonAlertPartyUpdate(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);
